import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  statusWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    background: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3, 4),
  },
  offerUpdatedAt: {
    fontSize: '11px',
    fontWeight: 500,
    color: theme.palette.labraText.description,
  },
  errorMsg: {
    margin: theme.spacing(-0.5, 0, 1.5, 0),
  },
  errorSubContent: {
    marginTop: theme.spacing(-0.5),
  },
  editButton: {
    marginTop: theme.spacing(1.5),
  },
  extendOfferExpiry: {
    fontSize: '14px !important',
    height: theme.spacing(2.5),
    minHeight: `${theme.spacing(2.5)} !important`,
  },
  expired: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cancellationInprogress: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  offerAccepted: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  offerAcceptedWrapper: {
    background: theme.palette.acceptedStatus.main,
    width: '100%',
    borderRadius: theme.spacing(1),
  },
  offerAcceptedBody: {
    padding: theme.spacing(0, 3),
  },
  acceptedSubheading: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2, 0),
  },
  acceptedButton: {
    background: theme.palette.acceptedStatus.main,
    fontSize: '14px !important',
    height: theme.spacing(2.5),
    minHeight: `${theme.spacing(2.5)} !important`,
  },
  viewSubscription: {
    height: '40px',
    background: theme.palette.text.white,
    '&:hover': {
      background: `${theme.palette.text.white} !important`,
    },
    minWidth: 'fit-content',
  },
  acceptedSubTitle: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    height: '20px',
  },
  offerExpiringSoon: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  modalText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    width: theme.spacing(52.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    '& p': {
      margin: 0,
    },
  },
  updateButtonContainer: {
    marginLeft: 'auto',
  },
  disabledEdit: {
    opacity: '39%',
  },
}))
